import React, { useState } from 'react';
import useAuth from '../../../hooks/useAuth';
import { Link, useNavigate } from 'react-router-dom';
import { Alert, Button, Form, Input, message, Spin } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

// import empresaService from "../../../services/empresaService";
import { API } from 'aws-amplify';
import { getUsuarioBackoffice } from '../../../graphql/queries';

export default function LoginForm() {
  const [isSubmit, setIsSubmit] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);

  const [alert, setAlert] = useState(null);
  const { loginUser } = useAuth();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    const request = API.graphql({
      query: getUsuarioBackoffice,
      variables: { correo: values.username },
    });
    const { data } = await request;
    if (data.getUsuarioBackoffice !== null) {
      try {
        setIsSubmit(true);
        setAlert(null);
        await loginUser(values);
        message.success('Bienvenido de nuevo');
        navigate('/');
      } catch (error) {
        console.error(error);
        message.error('Ocurrió un error');
        setAlert(error.message);
      } finally {
        setIsSubmit(false);
      }
    } else message.error('Este correo no posee permisos de acceso');
    /*
        try {
            setIsSubmit(true);
            setAlert(null);
            await loginUser(values);
            consultaTabla(values);
        } catch (error) {
            console.error(error);
            message.error("Ocurrió un error");
            setAlert(error.message);
        } finally {
            setIsSubmit(false);
        }

        */
  };

  if (isSubmit)
    return (
      <div className="p-10 text-center">
        <Spin />
        <p className="mt-2">Ingresando</p>
      </div>
    );

  return (
    <Form
      name="normal_login"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      size={'large'}
    >
      <Form.Item
        name="username"
        rules={[
          {
            required: true,
            message: 'Ingrese correo',
          },
        ]}
      >
        <Input prefix={<UserOutlined />} placeholder="Nombre de usuario" />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[
          {
            required: true,
            message: 'Ingrese Contraseña',
          },
        ]}
      >
        <Input.Password
          prefix={<LockOutlined />}
          type="password"
          placeholder="Contraseña"
          visibilityToggle={{
            visible: passwordVisible,
            onVisibleChange: setPasswordVisible,
          }}
        />
      </Form.Item>
      <Form.Item>
        {/* <Form.Item name="remember" valuePropName="checked" noStyle>
      <Checkbox>Recuerdame</Checkbox>
    </Form.Item> */}
        <Link to="#">¿Olvidaste la contraseña?</Link>
      </Form.Item>

      {alert && (
        <div className="mb-4">
          <Alert message={alert} type="error" showIcon>
            Usuario desconocido o contraseña incorrecta.
          </Alert>
        </div>
      )}
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Iniciar sesión
        </Button>
      </Form.Item>
    </Form>
  );
}
